<template>
<div>

  <!-- editor de texto -->
   <div v-show="this.editing" :style="style()" class="container-edition" ref="textEditor">
  </div>


  <div class="form-group float-right">
    <delete-confirmation-modal style="z-index: 9001; width: 100%; height: 100%;" ref="discardText" :custom="true" :title="$t('ct-discard-confirm')" :text="' '" :confirmMessage="$t('ct-discard-yes')" @confirm="closeModal" />

    <button @click="closeEditor(false)" class="btn btn-danger">{{ $t('ct-cancel') }}</button>
    <button @click="closeEditor(true)" class="btn btn-success">{{ $t('ct-save') }}</button>
  </div>

</div>

</template>
<script>

  // import Editor from '@tinymce/tinymce-vue';
  import FontList from './FontList';
  import _ from 'lodash';

  export default {
    components: {
      // 'editor': Editor,
      FontList
    },
    data() {
      let vm = this;

      let fontFormats = '';
      Object.keys(FontList.data().props.fontList).forEach(font => {
        fontFormats += font + '=' + FontList.data().props.fontList[font] + ';';
      });

      return {
        originalContent: '',
        idEditor: 0,
        text: '',
        editing: false,
        blur: true,
        editor: null,
        open: false,
        element: null,
        fonts: [
        {text: "Abuget", value: "abuget"},
          {text: "Adella", value: "adella"},
          {text: "Advantage", value: "advantage"},
          {text: "Amatic", value: "amatic"},
          {text: "Andale Mono", value: "andale mono, times"},
          {text: "Anton", value: "anton"},
          {text: "Arial", value: "arial, helvetica, sans-serif"},
          {text: "Arial Black", value: "arial black, avant garde"},
          {text: "Artega", value: "artega"},
          {text: "Assistant", value: "assistant"},
          {text: "Assistant Bold", value: "assistant bold"},
          {text: "Assistant Light", value: "assistant light"},
          {text: "Assistant Semibold", value: "assistant semibold"},
          {text: "Autobus", value: "autobus"},
          {text: "Barlow Extra Light", value: "barlow extra light"},
          {text: "Barlow Medium", value: "barlow medium"},
          {text: "Basic", value: "basic"},
          {text: "Bebas Neue", value: "bebas neue"},
          {text: "Best Week", value: "best week"},
          {text: "Book Antiqua", value: "book antiqua, palatino"},
          {text: "Breathe", value: "breathe"},
          {text: "Bree Serif", value: "bree serif"},
          {text: "Caudex", value: "caudex"},
          {text: "Caveat", value: "caveat"},
          {text: "Caveat Bold", value: "caveat bold"},
          {text: "Charrie", value: "charrie"},
          {text: "Chelsea Market", value: "chelsea market"},
          {text: "Cinzel", value: "cinzel"},
          {text: "Cinzel Semibold", value: "cinzel semibold"},
          {text: "Comic Sans MS", value: "comic sans ms, sans-serif"},
          {text: "Cookie", value: "cookie"},
          {text: "Coolvetica", value: "coolvetica"},
          {text: "Corben", value: "corben"},
          {text: "Cormorant Garamond Light", value: "cormorant garamond light"},
          {text: "Cormorant Garamond Semibold", value: "cormorant garamond semibold"},
          {text: "Courier New", value: "courier new, courier"},
          {text: "Courier New", value: "courier new"},
          {text: "Curve Bold", value: "curve bold"},
          {text: "Curve Regular", value: "curve regular"},
          {text: "Curve Slim", value: "curve slim"},
          {text: "Damion", value: "damion"},
          {text: "Dancing Script", value: "dancing script"},
          {text: "EB Garamond", value: "eb garamond"},
          {text: "EB Garamond Extrabold", value: "eb garamond extrabold"},
          {text: "Enriqueta", value: "enriqueta"},
          {text: "Enriqueta Bold", value: "enriqueta bold"},
          {text: "Enriqueta Medium", value: "enriqueta medium"},
          {text: "Enriqueta Semibold", value: "enriqueta semibold"},
          {text: "Exquite", value: "exquite"},
          {text: "Fahkwang", value: "fahkwang"},
          {text: "Fahkwang Medium", value: "fahkwang medium"},
          {text: "Feeling", value: "feeling"},
          {text: "Forum", value: "forum"},
          {text: "Frank Ruhl Libre", value: "frank ruhl libre"},
          {text: "Frank Ruhl Libre Bold", value: "frank ruhl libre bold"},
          {text: "Fraunces Bold", value: "fraunces bold"},
          {text: "Fraunces Light", value: "fraunces light"},
          {text: "Fraunces Thin", value: "fraunces thin"},
          {text: "Fredericka the Great", value: "fredericka the great"},
          {text: "Geist", value: "geist"},
          {text: "Geist Bold", value: "geist bold"},
          {text: "Geist Light", value: "geist light"},
          {text: "Geist Thin", value: "geist thin"},
          {text: "Georgia", value: "georgia, palatino"},
          {text: "Georgia Estate", value: "georgia estate"},
          {text: "Harshita", value: "harshita"},
          {text: "Heebo", value: "heebo"},
          {text: "Heebo Black", value: "heebo black"},
          {text: "Heebo Bold", value: "heebo bold"},
          {text: "Heebo Extralight", value: "heebo extralight"},
          {text: "Heebo Semibold", value: "heebo semibold"},
          {text: "Hell Deco", value: "hell deco"},
          {text: "Helsinki", value: "helsinki"},
          {text: "Helvetica", value: "helvetica"},
          {text: "Impact", value: "impact, chicago"},
          {text: "Jockey One", value: "jockey one"},
          {text: "Josefin Slab", value: "josefin slab"},
          {text: "Josefin Slab Bold", value: "josefin slab bold"},
          {text: "Jura", value: "jura"},
          {text: "Jura Bold", value: "jura bold"},
          {text: "Karantina", value: "karantina"},
          {text: "Karantina Light", value: "karantina light"},
          {text: "Kelly Slab", value: "kelly slab"},
          {text: "La Lemonti", value: "la lemonti"},
          {text: "La Lemonti Italic", value: "la lemonti italic"},
          {text: "Laisha", value: "laisha"},
          {text: "Lato", value: "Lato, sans-serif"},
          {text: "Lato Black", value: "Lato Black, sans-serif"},
          {text: "Lato Bold", value: "lato bold"},
          {text: "Lato Italic", value: "lato italic"},
          {text: "Lato Light", value: "Lato Light, sans-serif"},
          {text: "Lato Thin", value: "Lato Thin, sans-serif"},
          {text: "Lavener", value: "lavener"},
          {text: "Lexa", value: "lexa"},
          {text: "Lobster", value: "lobster"},
          {text: "Marck Script", value: "marck script"},
          {text: "Marmelad", value: "marmelad"},
          {text: "Monofonto", value: "monofonto"},
          {text: "Monoton", value: "monoton"},
          {text: "Montserrat", value: "Montserrat, sans-serif"},
          {text: "Montserrat Light", value: "Montserrat Light, sans-serif"},
          {text: "Montserrat Semi Bold", value: "Montserrat Semi Bold, sans-serif"},
          {text: "Mr De Haviland", value: "mr de haviland"},
          {text: "Muli", value: "Muli, sans-serif"},
          {text: "Muli Black", value: "Muli Black, sans-serif"},
          {text: "Muli Bold", value: "muli bold"},
          {text: "Muli Bold Italic", value: "muli bold italic"},
          {text: "Muli Italic", value: "muli italic"},
          {text: "Muli Light", value: "Muli Light, sans-serif"},
          {text: "Muli Semibold", value: "muli semibold"},
          {text: "Mutua", value: "mutua"},
          {text: "Niconne", value: "niconne"},
          {text: "Nobile", value: "nobile"},
          {text: "Nobile Bold", value: "nobile bold"},
          {text: "Noticia Text", value: "noticia text"},
          {text: "Nunito", value: "Nunito, sans-serif"},
          {text: "Open Sans", value: "Open Sans, helvetica, sans-serif"},
          {text: "Open Sans Bold", value: "open sans bold"},
          {text: "Oswald", value: "oswald"},
          {text: "Oswald Bold", value: "oswald bold"},
          {text: "Oswald Extralight", value: "oswald extralight"},
          {text: "Oswald Medium", value: "oswald medium"},
          {text: "Ottmar Hollington", value: "ottmar hollington"},
          {text: "Overlock", value: "overlock"},
          {text: "Patrick Hand", value: "patrick hand"},
          {text: "Play", value: "play"},
          {text: "Play Bold", value: "play bold"},
          {text: "Playfair Display", value: "Playfair Display, sans-serif"},
          {text: "Playfair Display Black", value: "playfair display black"},
          {text: "Playfair Display Black Italic", value: "playfair display black italic"},
          {text: "Playfair Display Bold", value: "playfair display bold"},
          {text: "Playfair Display Bold Italic", value: "playfair display bold italic"},
          {text: "Poppins", value: "poppins"},
          {text: "Poppins Bold", value: "poppins bold"},
          {text: "Poppins Bold Italic", value: "poppins bold italic"},
          {text: "Poppins Extralight", value: "poppins extralight"},
          {text: "Poppins Extralight Italic", value: "poppins extralight italic"},
          {text: "Poppins Italic", value: "poppins italic"},
          {text: "Poppins Semibold", value: "poppins semibold"},
          {text: "Poppins Semibold Italic", value: "poppins semibold italic"},
          {text: "Quicksand", value: "quicksand"},
          {text: "Quicksand Bold", value: "quicksand bold"},
          {text: "Quicksand Medium", value: "quicksand medium"},
          {text: "Quicksand Semibold", value: "quicksand semibold"},
          {text: "Raleway Bold", value: "raleway bold"},
          {text: "Raleway Bold Italic", value: "raleway bold italic"},
          {text: "Raleway Semibold", value: "raleway semibold"},
          {text: "Raleway Semibold Italic", value: "raleway semibold italic"},
          {text: "Roboto", value: "Roboto, sans-serif"},
          {text: "Roboto Black", value: "roboto black"},
          {text: "Roboto Black Italic", value: "roboto black italic"},
          {text: "Roboto Bold", value: "roboto bold"},
          {text: "Roboto Bold Italic", value: "roboto bold italic"},
          {text: "Roboto Italic", value: "roboto italic"},
          {text: "Roboto Light", value: "roboto light"},
          {text: "Roboto Light Italic", value: "roboto light italic"},
          {text: "Rozha One", value: "rozha one"},
          {text: "Rubik", value: "rubik"},
          {text: "Rubik Bold", value: "rubik bold"},
          {text: "Rubik Light", value: "rubik light"},
          {text: "Rubik Medium", value: "rubik medium"},
          {text: "Sacramento", value: "sacramento"},
          {text: "Sail", value: "sail"},
          {text: "Sarina", value: "sarina"},
          {text: "Seaside Resort", value: "seaside resort"},
          {text: "Space Grotesk", value: "space grotesk"},
          {text: "Space Grotesk Bold", value: "space grotesk bold"},
          {text: "Still Time", value: "still time"},
          {text: "Summer Pisces", value: "summer pisces"},
          {text: "Symbol", value: "symbol"},
          {text: "Syne", value: "syne"},
          {text: "Syne Bold", value: "syne bold"},
          {text: "Tahoma", value: "tahoma, arial, helvetica, sans-serif"},
          {text: "Terminal", value: "terminal, monaco"},
          {text: "Thirsty Caps", value: "thirsty caps"},
          {text: "Timeburner ", value: "timeburner"},
          {text: "Timeburner Bold", value: "timeburner bold"},
          {text: "Times New Roman", value: "times new roman, times"},
          {text: "Trebuchet MS", value: "trebuchet ms, geneva"},
          {text: "Verdana", value: "verdana, geneva"},
          {text: "Want Coffee", value: "want coffee"},
          {text: "Webdings", value: "webdings"},
          {text: "Wingdings", value: "wingdings, zapf dingbats"},
          {text: "Work Sans", value: "work sans"},
          {text: "Work Sans Bold", value: "work sans bold"},
          {text: "Work Sans Light", value: "work sans light"},
          {text: "Work Sans Medium", value: "work sans medium"},
          {text: "Yukita Black", value: "yukita black"},
          {text: "Yukita Bold", value: "yukita bold"},
          {text: "Yukita Extrabold", value: "yukita extrabold"},
          {text: "Yukita Light", value: "yukita light"},
          {text: "Yukita Medium", value: "yukita medium"},
          {text: "Yukita Regular", value: "yukita regular"},
          {text: "Yukita Semibold", value: "yukita semibold"}
        ],
        options: {
          // menubar: false,
          width: 580,
          left: 0,
          top: 0,
          plugins: 'autoresize autolink directionality  visualblocks visualchars image link media template codesample table charmap hr pagebreak nonbreaking  toc insertdatetime advlist lists textcolor wordcount   imagetools  contextmenu colorpicker textpattern help',
          toolbar1: 'undo redo | formatselect fontselect fontsizeselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link textshadow  | save',
          fontsize_formats: "5px 6px 7px 8px 9px 10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px 37px 38px 39px 40px 41px 42px 43px 44px 45px 46px 47px 48px 49px 50px 51px 52px 53px 54px 55px 56px 57px 58px 59px 60px 61px 62px 63px 64px 65px 66px 67px 68px 69px 70px 71px 72px 73px 74px 75px 76px 77px 78px 79px 80px 81px 82px 83px 84px 85px 86px 87px 88px 89px 90px 91px 92px 93px 94px 95px 96px 97px 98px 99px 100px 101px 102px 103px 104px 105px 106px 107px 108px 109px 110px 111px 112px 113px 114px 115px 116px 117px 118px 119px 120px",
          font_formats: fontFormats,
          content_css: "" +
            "/static/FontList.css?v=" + new Date().getTime() +
            ",/static/custom_content.css?v=" + new Date().getTime() +
            ",/static/bootstrap.min.css?v=" + new Date().getTime() +
            ",/static/ck.css?v=" + new Date().getTime() +
            ",/static/ckeditor4/content.css?v=" + new Date().getTime(),
        }
      };
    },
    methods: {
      style() {


        return `width: ${this.options.width};
                left:  ${this.options.left};
                top:  ${this.options.top};
                height: 650px`
      },
      closeEditor(save) {

        let vm = this;


        if(save) {
            vm.element.updateContent(vm.editor.getData());


            this.$snotify.success(
              this.$t('ct-saved-successfully')
            );

            this.$emit('closePopup');


            setTimeout(() => {
              for (let instance in CKEDITOR.instances) {
                CKEDITOR.instances[instance].destroy();
              }
            }, 0)
            vm.editing = false;
            vm.open = false;
        } else {
          vm.$refs.discardText.open();
        }

      },
      closeModal() {
        let vm = this;
        vm.element.updateContent(vm.originalContent);
        this.$emit('closePopup');


        setTimeout(() => {
          for (let instance in CKEDITOR.instances) {
            CKEDITOR.instances[instance].destroy();
          }
        }, 0)
        vm.editing = false;
        vm.open = false;
      },
      showEditor(elem) {

        let vm = this;
        let change = false;
        let hide = false;

        if (!vm.open) {

          vm.open = true;
          let idEditor = vm.idEditor++;

          for (var instance in CKEDITOR.instances) {
            CKEDITOR.instances[instance].updateElement();
          }

          $('.text-editor-cke').detach();
          $('.cke_textarea_inline').detach();

          var el_aplly = document.getElementById('edit-text-modal')

          this.$nextTick(() => {

            $('<textarea>')
              .attr({
                'id': 'editor' + idEditor,
                'name': 'editor' + idEditor
              })
              .val('')
              .addClass('text-editor-cke')
              .appendTo(el_aplly);

            vm.editing = true;
            vm.element = elem;
            elem.internal_config.content = elem.internal_config.content.replace(/display:block;/g, "");
            elem.internal_config.content = elem.internal_config.content.replace(/line-height:/g, "display:block;line-height:");
            vm.text = _.clone(elem.internal_config.content);
            vm.originalContent = _.clone(elem.internal_config.content);

            if (!$(vm.text).hasClass('default') && !$(vm.text).hasClass('clean-text-css')) {
              $(vm.text).addClass('default');

              let someVar = $(vm.text); // convert to jquery object
              someVar.addClass('default');

              let vmText = '';
              $(someVar).each((textEl) => {
                if (typeof $(someVar).get(textEl).outerHTML !== 'undefined')
                  vmText += $(someVar).get(textEl).outerHTML;
              });

              vm.text = vmText;
            }

            if ($(vm.text).hasClass('default')) {
              hide = false;
            }

            document.body.style.setProperty('--width-text-editor', el_aplly.getBoundingClientRect().width + 30 + 'px');

            vm.options.left = el_aplly.getBoundingClientRect().left + 'px';
            vm.options.height = el_aplly.getBoundingClientRect().height + 'px';
            vm.options.width = el_aplly.getBoundingClientRect().width + 'px';

            let topElement = el_aplly.getBoundingClientRect().top;
            if (topElement < 120) {
              topElement = 120;
            }
            vm.options.top = (topElement + window.scrollY) + 'px';

            let str = '';
            vm.fonts.forEach((font) => {
              str += font.text + '/' + font.value + ';';
            });


            CKEDITOR.replace('editor' + idEditor, {
              height: 480,
              baseFloatZIndex: 1005,
              font_names: str
            }).setData(vm.text);

            let editor = CKEDITOR.instances['editor' + idEditor];

            editor.on('change', function (evt) {
              if (change) {
                change = !change;
                let textEdition = evt.editor.getData();
                textEdition = textEdition.replace(/display:block;/g, "");
                textEdition = textEdition.replace(/line-height:/g, "display:block;line-height:");
                evt.editor.setData(textEdition);
              }
            });

            // editor.on('blur', function (evt) {
            //   if (vm.blur) {
            //     vm.editing = false;
            //     // vm.element.updateContent(evt.editor.getData());
            //     vm.element.updateContent(vm.originalContent);

            //     setTimeout(() => {
            //       for (let instance in CKEDITOR.instances) {
            //         CKEDITOR.instances[instance].destroy();
            //       }
            //     }, 0)
            //     vm.open = false;
            //   }
            // });
            editor.on('instanceReady', function (evt) {

              this.document.appendStyleSheet( 'https://cdn.materialdesignicons.com/4.4.95/css/materialdesignicons.min.css' );
              this.document.appendStyleSheet( 'https://cheetah-editor.builderall.com/static/ck.css' );
              this.document.appendStyleSheet( 'https://cheetah-editor.builderall.com/static/ckeditor4/contents.css' );
              this.document.appendStyleSheet( 'https://cheetah-editor.builderall.com/static/bootstrap.min.css' );



              elem.editingTrue();

              $('.cke_combo__lineheight').on('click', () => {
                change = true;
              });
              console.log(hide);
              if (hide) {
                $('.cke_combo__lineheight').hide();
              }
            });
            editor.on('key', function (e) {
              if (e.data.keyCode == '13') {
                e.cancel();
                editor.insertHtml('<br>');
              }
            });


            editor.on('selectionChange', function (evt) {
              $('.mdi:not(.mdi-tmp)').removeClass('mdi-focus')
            });

            vm.blur = true;

            vm.editor = editor;
          })
        } else {

          try {
            for (let instance in CKEDITOR.instances) {
              // CKEDITOR.instances[instance].destroy(true);
            }
          }catch (e) {
            console.log(e);
          }

          vm.open = false;

          this.$nextTick(() => {
            // vm.editing = false;
            // elem.updateContent(elem.internal_config.content);
          })
        }
      }

    },
    mounted() {
      let vm = this;
      // this.$root.$on('blurEvent', (value) => {
      //   vm.blur = value;
      // });

      this.$root.$on('addFontsCk', (params) => {
        vm.fonts.push(params);
        vm.fonts.sort((a, b) => (a.text > b.text) ? 1 : -1)
      });

      this.$root.$on('destroyCk', () => {
        vm.editing = false;

        setTimeout(() => {
          try {
            vm.editor.destroy();
          }catch (e) {
          }
        }, 0)
        vm.open = false;
      });


    }
  }
</script>

<style lang="scss" scoped>

  .container-edition {
    position: absolute;
  }

  .container-edition > a {
   color: blue;
  }

  .cke_panel_listItem span {
    font-size: 15px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/base/TextEditorOpen.vue